import React from "react";
import { View } from "react-native";
import Svg, {
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
  Circle,
  G,
  Path
} from "react-native-svg";

/**
 * Props for the Logo component
 */
interface LogoProps {
  /** Width of the logo in pixels (default: 200) */
  width?: number;
  /** Height of the logo in pixels (default: 200) */
  height?: number;
  /** Additional styles to apply to the container View */
  style?: any;
}

/**
 * Logo component that renders the Serenity app logo using react-native-svg
 */
export default function Logo({ width = 200, height = 200, style }: LogoProps) {
  return (
    <View style={style}>
      <Svg viewBox="0 0 200 200" width={width} height={height}>
        <Defs>
          {/* Adjusted gradients with stronger color and softer transparency */}
          <LinearGradient id="grad1" x1="0" y1="0" x2="1" y2="0">
            <Stop offset="0%" stopColor="hsl(90, 35%, 70%)" stopOpacity="1" />
            <Stop
              offset="100%"
              stopColor="hsl(95, 20%, 70%)"
              stopOpacity="0.6"
            />
          </LinearGradient>
          <LinearGradient id="grad2" x1="0" y1="0" x2="1" y2="0">
            <Stop offset="0%" stopColor="hsl(105, 35%, 45%)" stopOpacity="1" />
            <Stop
              offset="100%"
              stopColor="hsl(110, 20%, 45%)"
              stopOpacity="0.6"
            />
          </LinearGradient>
          <LinearGradient id="grad3" x1="0" y1="0" x2="1" y2="0">
            <Stop offset="0%" stopColor="hsl(35, 60%, 70%)" stopOpacity="1" />
            <Stop
              offset="100%"
              stopColor="hsl(40, 35%, 70%)"
              stopOpacity="0.6"
            />
          </LinearGradient>
          <LinearGradient id="grad4" x1="0" y1="0" x2="1" y2="0">
            <Stop offset="0%" stopColor="hsl(220, 50%, 65%)" stopOpacity="1" />
            <Stop
              offset="100%"
              stopColor="hsl(225, 30%, 65%)"
              stopOpacity="0.6"
            />
          </LinearGradient>
          <LinearGradient id="grad5" x1="0" y1="0" x2="1" y2="0">
            <Stop offset="0%" stopColor="hsl(250, 45%, 75%)" stopOpacity="1" />
            <Stop
              offset="100%"
              stopColor="hsl(255, 30%, 75%)"
              stopOpacity="0.6"
            />
          </LinearGradient>

          {/* Circle mask */}
          <ClipPath id="circleClip">
            <Circle cx="100" cy="100" r="95" />
          </ClipPath>
        </Defs>

        <G clipPath="url(#circleClip)">
          {/* Top Segment */}
          <Path
            fill="url(#grad1)"
            d="M0,5 Q100,-20 200,5 L200,39 C130,9 70,69 0,39 Z"
          />

          {/* Segment 2 */}
          <Path
            fill="url(#grad2)"
            d="M0,43 C50,75 150,11 200,43 L200,77 C150,45 50,107 0,77 Z"
          />

          {/* Segment 3 */}
          <Path
            fill="url(#grad3)"
            d="M0,81 C50,113 150,49 200,81 L200,115 C150,83 50,145 0,115 Z"
          />

          {/* Segment 4 */}
          <Path
            fill="url(#grad4)"
            d="M0,119 C50,151 150,87 200,119 L200,153 C150,121 50,183 0,153 Z"
          />

          {/* Bottom Segment */}
          <Path
            fill="url(#grad5)"
            d="M0,157 C70,189 130,125 200,157 L200,195 Q100,215 0,195 Z"
          />
        </G>
      </Svg>
    </View>
  );
}
